import { primaryKey, headerCode, inputType, required, length, order, pattern, editable, Describer, visible, GceEntity, relation, currency } from './gce-management';
import { GceInvoicePerson } from './gce-invoice-person';
import { GceClinic } from './gce-clinic';

/**
 * GceInvoice -> table: medici_fatturazione_compensi
 */
export class GceInvoicePersonCompensation extends GceEntity {
    @headerCode('GCE.GCEINVOICEPERSONCOMPENSATION.IDFATTURAZIONE')
    @inputType('hidden')
    @order(1)
    idfatturazione: number;

    @headerCode('GCE.GCEINVOICEPERSONCOMPENSATION.COD_CLINICA')
    @inputType('select')
    @length(255)
    //@relation("GceClinic", {columnRel:'code_c', columnDescr:['legalentity', 'nome']})
    @relation("GceClinic", {columnRel:'code_c', columnDescr:['nome']})
    @required()
    @order(2)
    cod_clinica: string;

    @headerCode('GCE.GCEINVOICEPERSONCOMPENSATION.DATA_INZIO')
    @inputType('date')
    @order(3)
    data_inzio: Date | string;

    @headerCode('GCE.GCEINVOICEPERSONCOMPENSATION.DATA_FINE')
    @inputType('date')
    @order(4)
    data_fine: Date | string;

    @headerCode('GCE.GCEINVOICEPERSONCOMPENSATION.GETTONE_GIORNALIERO')
    @inputType('number')
    @pattern('00000.00')
    @currency({ isCurrency: true, currencyCode: 'EUR', display: 'symbol', digitsInfo: '2.2-2', locale: 'it' })
    @order(5)
    gettone_giornaliero: number;

    @headerCode('GCE.GCEINVOICEPERSONCOMPENSATION.DIREZIONE_SANITARIA')
    @inputType('number')
    @pattern('00000.00')
    @currency({ isCurrency: true, currencyCode: 'EUR', display: 'symbol', digitsInfo: '2.2-2', locale: 'it' })
    @order(6)
    direzione_sanitaria: number;

    @headerCode('GCE.GCEINVOICEPERSONCOMPENSATION.COMPENSO_FISSO')
    @inputType('number')
    @pattern('00000.00')
    @currency({ isCurrency: true, currencyCode: 'EUR', display: 'symbol', digitsInfo: '2.2-2', locale: 'it' })
    @order(7)
    compenso_fisso: number;

    @headerCode('GCE.GCEINVOICEPERSONCOMPENSATION.MINIMO_GARANTITO')
    @inputType('number')
    @pattern('00000.00')
    @currency({ isCurrency: true, currencyCode: 'EUR', display: 'symbol', digitsInfo: '2.2-2', locale: 'it' })
    @order(8)
    minimo_garantito: number;

    @headerCode('GCE.GCEINVOICEPERSONCOMPENSATION.DIREZIONE_AREA_CLINICA')
    @inputType('number')
    @pattern('00000.00')
    @currency({ isCurrency: true, currencyCode: 'EUR', display: 'symbol', digitsInfo: '2.2-2', locale: 'it' })
    @order(9)
    direzione_area_clinica: number;

    @headerCode('GCE.GCEINVOICEPERSONCOMPENSATION.PERIODO_DS')
    //@inputType('number')
    @inputType('hidden')
    @order(10)
    periodo_ds: number;

    @headerCode('GCE.GCEINVOICEPERSONCOMPENSATION.MESE_DS')
    //@inputType('number')
    @inputType('hidden')
    @order(11)
    mese_ds: number;

    @headerCode('GCE.GCEINVOICEPERSONCOMPENSATION.PERIODO_CF')
    @inputType('number')
    @order(12)
    periodo_cf: number;

    @headerCode('GCE.GCEINVOICEPERSONCOMPENSATION.MESE_CF')
    @inputType('number')
    @order(13)
    mese_cf: number;

    @headerCode('GCE.GCEINVOICEPERSONCOMPENSATION.PERIODO_DAC')
    //@inputType('number')
    @inputType('hidden')
    @order(14)
    periodo_dac: number;

    @headerCode('GCE.GCEINVOICEPERSONCOMPENSATION.MESE_DAC')
    //@inputType('number')
    @inputType('hidden')
    @order(15)
    mese_dac: number;

    @headerCode('GCE.GCEINVOICEPERSONCOMPENSATION.PCT_FINANZIAMENTO')
    @inputType('percentage')
    @pattern('000.00')
    @order(16)
    pct_finanziamento: number;

    @headerCode('GCE.GCEINVOICEPERSON.PAGAM_DIREZIONI_NON_MENSILE')
    @inputType('boolean')
    @editable(true)
    @order(17)
    flg_pagam_direzioni_non_mensile: boolean;

    @headerCode('GCE.GCEINVOICEPERSON.FLAG_MESI_PAG_DIREZ')
    @inputType('mont')
    @editable(true)
    @order(18)
    mesi_pagam_direzioni: string;

    @headerCode('GCE.GCEINVOICEPERSON.PAGAM_DIREZIONI_AREA_NON_MENSILE')
    @inputType('boolean')
    @editable(true)
    @order(17)
    flg_pagam_dir_area_non_mensile: boolean;

    @headerCode('GCE.GCEINVOICEPERSON.FLAG_MESI_PAG_DIR_AREA')
    @inputType('mont2')
    @editable(true)
    @order(18)
    mesi_pagam_dir_area: string;

    @headerCode('GCE.GCEINVOICEPERSON.GETTONE_GIORNALIERO_IGIENTISTA_DMS')
    @inputType('number')
    @pattern('00000.00')
    @editable(true)
    @order(19)
    gettone_giornaliero_igienista_dms:number;

    @headerCode('GCE.GCEINVOICEPERSON.GETTONE_GIORNALIERO_RESIDENT')
    @inputType('number')
    @pattern('00000.00')
    @editable(true)
    @order(20)
    gettone_giornaliero_resident:number;

    @headerCode('GCE.GCEINVOICEPERSON.MASSIMO_GIORNI_RESIDENT')
    @inputType('number')
    @editable(true)
    @order(21)
    massimo_giorni_resident:number;

    @headerCode('GCE.GCEINVOICEPERSON.VARIABILE1_TRIMESTRE_RESIDENT')
    @inputType('number')
    @pattern('00000.00')
    @editable(true)
    @order(22)
    variabile1_trimestre_resident:number;

    @headerCode('GCE.GCEINVOICEPERSON.VARIABILE2_TRIMESTRE_RESIDENT')
    @inputType('number')
    @pattern('00000.00')
    @editable(true)
    @order(23)
    variabile2_trimestre_resident:number;

    @headerCode('GCE.GCEINVOICEPERSON.EXTRA_BONUS_TRIMESTRE_RESIDENT')
    @inputType('number')
    @pattern('00000.00')
    @editable(true)
    @order(24)
    extra_bonus_trimestre_resident:number;

    @headerCode('GCE.GCEINVOICEPERSONCOMPENSATION.GG_FERIE_ANNO_RESIDENT')
    @inputType('number')
    @pattern('00')
    @order(25)
    gg_ferie_anno_resident:number;
   
    @headerCode('GCE.GCEINVOICEPERSONCOMPENSATION.DATA_INIZIO_CALCOLO_FERIE')
    @inputType('date')
    @order(26)
    data_inizio_calcolo_ferie: Date | string;
    
    constructor();
    constructor(idfatturazione: number, cod_clinica: string, data_inzio: Date | string, data_fine: Date | string, gettone_giornaliero: number, direzione_sanitaria: number, compenso_fisso: number, minimo_garantito: number, direzione_area_clinica: number, periodo_ds: number, mese_ds: number, periodo_cf: number, mese_cf: number, periodo_dac: number, mese_dac: number, pct_finanziamento: number , 
        flg_pagam_direzioni_non_mensile :boolean, mesi_pagam_direzioni: string, flg_pagam_dir_area_non_mensile: boolean, mesi_pagam_dir_area: string, gettone_giornaliero_igienista_dms:number, gettone_giornaliero_resident:number,massimo_giorni_resident:number,variabile1_trimestre_resident:number,variabile2_trimestre_resident:number,extra_bonus_trimestre_resident:number,gg_ferie_anno_resident:number, data_inizio_calcolo_ferie: Date | string);
    constructor(idfatturazione?: number, cod_clinica?: string, data_inzio?: Date | string, data_fine?: Date | string, gettone_giornaliero?: number, direzione_sanitaria?: number, compenso_fisso?: number, minimo_garantito?: number, direzione_area_clinica?: number, periodo_ds?: number, mese_ds?: number, periodo_cf?: number, mese_cf?: number, periodo_dac?: number, mese_dac?: number, pct_finanziamento?: number ,
        flg_pagam_direzioni_non_mensile? :boolean, mesi_pagam_direzioni?: string, flg_pagam_dir_area_non_mensile?: boolean, mesi_pagam_dir_area?: string, gettone_giornaliero_igienista_dms?:number, gettone_giornaliero_resident?:number,massimo_giorni_resident?:number,variabile1_trimestre_resident?:number,variabile2_trimestre_resident?:number,extra_bonus_trimestre_resident?:number,gg_ferie_anno_resident?:number, data_inizio_calcolo_ferie?: Date | string){
        super();
        this.idfatturazione = idfatturazione;
        this.cod_clinica = cod_clinica;
        this.data_inzio = data_inzio;
        this.data_fine = data_fine;
        this.gettone_giornaliero = gettone_giornaliero;
        this.direzione_sanitaria = direzione_sanitaria;
        this.compenso_fisso = compenso_fisso;
        this.minimo_garantito = minimo_garantito;
        this.direzione_area_clinica = direzione_area_clinica;
        this.periodo_ds = periodo_ds;
        this.mese_ds = mese_ds;
        this.periodo_cf = periodo_cf;
        this.mese_cf = mese_cf;
        this.periodo_dac = periodo_dac;
        this.mese_dac = mese_dac;
        this.pct_finanziamento = pct_finanziamento;
        this.flg_pagam_direzioni_non_mensile = flg_pagam_direzioni_non_mensile;
        this.mesi_pagam_direzioni = mesi_pagam_direzioni;
        this.flg_pagam_dir_area_non_mensile=flg_pagam_dir_area_non_mensile;
        this.mesi_pagam_dir_area=mesi_pagam_dir_area;

        this.gettone_giornaliero_igienista_dms=gettone_giornaliero_igienista_dms;
        this.gettone_giornaliero_resident=gettone_giornaliero_resident;
        this.massimo_giorni_resident=massimo_giorni_resident;
        this.variabile1_trimestre_resident=variabile1_trimestre_resident;
        this.variabile2_trimestre_resident=variabile2_trimestre_resident;
        this.extra_bonus_trimestre_resident=extra_bonus_trimestre_resident;
        this.gg_ferie_anno_resident=gg_ferie_anno_resident;
        this.data_inizio_calcolo_ferie=data_inizio_calcolo_ferie;
    }

    static getStructure():Array<any>{
        let structure:any[] = Describer.getStructure(new GceInvoicePersonCompensation());
        structure.push(...this.getActions());
        return structure;
    }
    protected static getActions():any[]{
        let actions:any[] = [];
        return actions;
    }

    static parse(data:any):GceInvoicePersonCompensation{
        let gipc = new GceInvoicePersonCompensation(
            data['IDFATTURAZIONE'],
            data['COD_CLINICA'],
            data['DATA_INZIO'],
            data['DATA_FINE'],
            data['GETTONE_GIORNALIERO'],
            data['DIREZIONE_SANITARIA'],
            data['COMPENSO_FISSO'],
            data['MINIMO_GARANTITO'],
            data['DIREZIONE_AREA_CLINICA'],
            data['PERIODO_DS'],
            data['MESE_DS'],
            data['PERIODO_CF'],
            data['MESE_CF'],
            data['PERIODO_DAC'],
            data['MESE_DAC'],
            data['PCT_FINANZIAMENTO'],
            data['FLG_PAGAM_DIREZIONI_NON_MENSILE'],
            data['MESI_PAGAM_DIREZIONI'],
            data['FLG_PAGAM_DIR_AREA_NON_MENSILE'],
            data['MESI_PAGAM_DIR_AREA'],
            data['GETTONE_GIORNALIERO_IGIENTISTA_DMS'],
            data['GETTONE_GIORNALIERO_RESIDENT'],
            data['MASSIMO_GIORNI_RESIDENT'],
            data['VARIABILE1_TRIMESTRE_RESIDENT'],
            data['VARIABILE2_TRIMESTRE_RESIDENT'],
            data['EXTRA_BONUS_TRIMESTRE_RESIDENT'],
            data['GG_FERIE_ANNO_RESIDENT'],
            data['DATA_INIZIO_CALCOLO_FERIE']
        );
        return gipc;
    }
    
}
